import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-mte-input',
  templateUrl: './mte-input.component.html',
  styleUrls: ['./mte-input.component.scss']
})
export class MteInputComponent implements OnInit {
  @Input() control: any;
  @Input() label: string;
  @Input() type: string = 'text'; // Default to text
  @Input() isRequired: boolean = false;
  @Input() pattern: string;
  @Input() isTextArea: boolean = false;
  @Input() errorMessage: string = '*This field is required';
  @Input() layout: string = "horizontal";

  constructor() { }

  ngOnInit(): void {
    this.label = this.isRequired ? this.label + "*" : this.label;
  }

  get showError(): boolean {
    return this.control.invalid && this.control.touched;
  }

}
